import React from 'react';
import { useAuthMethod } from '../../hooks/useAuth';
import { PasswordCheckoutAuthentication } from './PasswordCheckoutAuthentication';
import { PasswordlessCheckoutAuthentication } from './PasswordlessCheckoutAuthentication';

export const CheckoutAuthentication: React.FC = () => {
  const authMethod = useAuthMethod({ authLocation: 'checkout' });

  if (authMethod === 'password') {
    return <PasswordCheckoutAuthentication />;
  }

  return <PasswordlessCheckoutAuthentication />;
};
